import * as React from 'react';

import { ActivityStatus } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';
import Backbone from 'backbone';
import { useSelector } from 'react-redux';

import { Tab, TabGroup } from '~shared/components/TabsV2';
import {
  SelectableTab,
  useMapRouteToSelectedTab,
} from '~teacher/context/CurrentRouteContext/hooks';
import { useActivityByInstanceId } from '~teacher/hook';
import { selectCurrentRoomActivity } from '~teacher/slices/teacher/teacherSelector';

import { SmallActivityStatusIcon } from '../ActivityStatusIcons';
import { useShouldShowDiscoverTab } from '../useShouldShowDiscoverTab';

interface DesktopNavbarProps {
  isVisible: boolean;
}
export function DesktopNavbar({ isVisible }: DesktopNavbarProps) {
  const shouldShowDiscoverTab = useShouldShowDiscoverTab();
  const selectedTab = useMapRouteToSelectedTab();
  const { isLive, activityInstanceId } = useSelector(selectCurrentRoomActivity);
  const activityQuery = useActivityByInstanceId({
    activityInstanceId,
    pubnub: window.pubnub,
  });

  const isActivityPaused =
    activityQuery?.data?.activity.state === ActivityStatus.Paused;

  if (!isVisible) return null;

  // This function is only called when a user explicitly clicks on a tab
  const handleTabClick = (selectedItem: string) => {
    Backbone.history.navigate(selectedItem, { trigger: true });
  };

  return (
    <div
      data-testid="desktop-navbar"
      className="hidden tb:block max-w-xl lg:max-w-2xl xl:max-w-6xl"
    >
      <div className="gap-4">
        <TabGroup className="trackless" activation="manual">
          {/*Hidden tab for profile section*/}
          <Tab
            slot="nav"
            className={'hidden'}
            active={selectedTab === SelectableTab.ProfileBilling}
            panel={SelectableTab.ProfileBilling}
          ></Tab>
          {/*Hidden tab for profile section*/}
          <Tab
            slot="nav"
            className={'hidden'}
            active={selectedTab === SelectableTab.ProfileInfo}
            panel={SelectableTab.ProfileInfo}
          ></Tab>

          <Tab
            slot="nav"
            active={selectedTab === SelectableTab.Launch}
            panel={SelectableTab.Launch}
            onClick={() => handleTabClick(SelectableTab.Launch)}
          >
            {translate('Launch')}
          </Tab>
          <Tab
            slot="nav"
            active={selectedTab === SelectableTab.Quizzes}
            panel={SelectableTab.Quizzes}
            onClick={() => handleTabClick(SelectableTab.Quizzes)}
          >
            {translate('Library')}
          </Tab>
          {shouldShowDiscoverTab && (
            <Tab
              slot="nav"
              active={selectedTab === SelectableTab.Discover}
              panel={SelectableTab.Discover}
              onClick={() => handleTabClick(SelectableTab.Discover)}
            >
              {translate('Discover')}
            </Tab>
          )}
          <Tab
            slot="nav"
            active={selectedTab === SelectableTab.Rooms}
            panel={SelectableTab.Rooms}
            onClick={() => handleTabClick(SelectableTab.Rooms)}
          >
            {translate('Rooms')}
          </Tab>
          <Tab
            slot="nav"
            active={selectedTab === SelectableTab.Reports}
            panel={SelectableTab.Reports}
            onClick={() => handleTabClick(SelectableTab.Reports)}
          >
            {translate('Reports')}
          </Tab>
          <Tab
            slot="nav"
            active={selectedTab === SelectableTab.LiveResults}
            panel={SelectableTab.LiveResults}
            onClick={() => handleTabClick(SelectableTab.LiveResults)}
          >
            {translate('Live Results')}
            <SmallActivityStatusIcon
              status={(() => {
                if (isActivityPaused) {
                  return ActivityStatus.Paused;
                } else if (isLive) {
                  return ActivityStatus.Running;
                } else {
                  return null;
                }
              })()}
              className="inline-block absolute top-2 right-6px"
            />
          </Tab>
        </TabGroup>
      </div>
    </div>
  );
}
